import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';

import { Account } from '../../api/types';
import config from '../../config';
import { useAxios } from '../../context/AxiosContextProvider';
import useAccountV2Query from '../useAccountV2Query';

async function update(
  axios: AxiosInstance,
  account_id: number,
  status: number,
  username: string,
  password: any,
  random_password: boolean,
): Promise<Account> {
  const { data } = await axios.put(`${config.apiBaseUrl}/op/v2/account/${account_id}`, {
    status: status,
    username: username,
    password: password,
    random_password: random_password,
  });
  return data.data;
}
export default function useUpdateAccountStatusMutation(account_id: number) {
  const queryClient = useQueryClient();
  const axios = useAxios();
  return useMutation({
    mutationKey: ['UpdateAccoutnStatus', account_id],
    mutationFn: (params: { account_id: number; status: number; username: string; password: any; random_password: boolean }) =>
      update(axios, params.account_id, params.status, params.username, params.password, params.random_password),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: useAccountV2Query.getKey(account_id),
      });
    },
  });
}
